<template>
  <div>
    <!-- Edit -->
    <a-modal
      :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 1080"
      v-model="visible"
      title="Save Exam Instruction"
      onOk="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSave">Save Exam Instruction</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input exam instruction name!' }]}]"
            />
          </a-form-item>
          <a-form-item label="Description">
            <div style="line-height: 1;">
              <!-- <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor> -->
              <neo-ckeditor :initialValue="editorData" @change="handleEditorChange"></neo-ckeditor>
            </div>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import NeoCkeditor from '@/components/ckeditor'
import { pick, mapValues } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'ExamInstructionForm',
  components: {
    NeoCkeditor,
  },
  mounted: function () {
    this.$eventBus.$on('openExamInstructionFormModal', this.showModal)
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      examInstructionId: null,
      editorData: '',
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    handleEditorChange({ value }) {
      this.editorData = value
    },
    showModal: function(examInstructionId) {
      this.visible = true

      if (examInstructionId) {
        this.examInstructionId = examInstructionId
        this.loading = true
        this.spinning = true
        this.$http.get('/api/online-exam/instruction/' + examInstructionId).then(({ data }) => {
          const editData = pick({ ...data.data }, ['name', 'description'])
          const fieldsData = mapValues({ ...editData }, function(value) {
            return value !== null ? value : undefined
          })
          this.form.setFieldsValue(fieldsData)
          this.editorData = data.data.description
          this.spinning = false
          this.loading = false
        })
      } else {
        this.examInstructionId = null
        this.editorData = ''
        this.form.resetFields()
      }
    },
    handleSave: function (e) {
      this.loading = true

      if (this.examInstructionId) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$confirm({
              title: `Are you sure you want to update ${values.name}?`,
              content: `Click on the OK button to update the details!`,
              onOk: () => {
                this.$http
                  .post('/api/online-exam/instruction/update/' + this.examInstructionId, {
                    name: values.name,
                    description: this.editorData,
                  })
                  .then(() => {
                    this.$emit('saved')
                    this.loading = false
                    this.visible = false
                    this.$notification['success']({
                      message: 'Successfully edited',
                      description: 'Exam instruction updated successfully!',
                    })
                  })
                  .catch(error => {
                    this.loading = false
                    this.$neoNotify.error(error)
                  })
              },
              onCancel: () => {
                this.loading = false
                this.examInstructionId = null
                this.editorData = ''
              },
            })
          }
        })
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$confirm({
              title: `Are you sure you want to add ${values.name}?`,
              content: `Click on the OK button to add the instruction!`,
              onOk: () => {
                this.$http
                  .post('/api/online-exam/instruction', {
                    name: values.name,
                    description: this.editorData,
                  })
                  .then(() => {
                    this.$emit('saved')
                    this.loading = false
                    this.visible = false
                    this.$notification['success']({
                      message: 'Successfully saved',
                      description: 'Exam instruction saved successfully!',
                    })
                    this.examInstructionId = null
                    this.editorData = ''
                  })
                  .catch(error => {
                    this.loading = false
                    this.$neoNotify.error(error)
                  })
              },
              onCancel: () => {
                this.loading = false
                this.examInstructionId = null
                this.editorData = ''
              },
            })
          }
        })
      }
    },
    handleCancel(e) {
      this.visible = false
      this.examInstructionId = null
      this.editorData = ''
      this.form.resetFields()
    },
  },
}
</script>
